import { render } from "./DownloadablesSlider.vue?vue&type=template&id=235a01f4"
import script from "./DownloadablesSlider.vue?vue&type=script&lang=js"
export * from "./DownloadablesSlider.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__